import React, { useEffect } from 'react'




import Box from '@mui/material/Box';
import {  SERVER_CHAT } from '../../constants';






export const RocketchatComponent = () => {







  useEffect(() => {

    window.open(SERVER_CHAT , '_blank');
  }, [])



  return (


    <Box dir="ltr" sx={{
      height: '100%', width: '100%', '& .cold': {
        backgroundColor: '#b9d5ff91',
        color: '#1a3e72',
      },
      '& .hot': {
        backgroundColor: '#ff943975',
        color: '#1a3e72',
      },
    }} >
        
        {/* Meteor.loginToken15kqMBfTax1Kw_30KbkIn5-jgH8iJIQpj2D6wUgapa-
Meteor.loginToken */}
      {/* {showLoader &&
        <div id="spinner" style={{ alignSelf: 'center', height: "100%", width: "100%", textAlign: "-webkit-center" }}>
          <div>
            <img src="laodingchat.gif" />
          </div>
        </div>} */}

      {/* {(permissions?.includes(ROLES.SUPER_ADMIN || permissions?.includes(ROLES.USERS_ADMIN || permissions?.includes(ROLES.ANBAAR_ADMIN || permissions?.includes(ROLES.SALE_ADMIN) && <ReferenceInput variant="outlined" label=" پردازنده" source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>} */}
      {/* {((permissions?.includes(ROLES.SUPER_ADMIN) || permissions?.includes(ROLES.USERS_ADMIN) || permissions?.includes(ROLES.ANBAAR_ADMIN) || permissions?.includes(ROLES.SALE_ADMIN))
        && endpointCalled) ? */}

     
    </Box >

  )
};

